import { RemoteAdminData, RemoteData } from 'app/infrastructure/remote-data';
import { ApiResponse } from 'app/types-shared';
import { DefaultFiltersEndpoints } from './constants';
import { FilterDomainWire, DefaultFilterMetadataWire } from './types';

export const api = {

  loadFilterDomains: async (endpoints: DefaultFiltersEndpoints): Promise<FilterDomainWire> => {
    const response = await new RemoteData(endpoints.filterDomains)
      .resource<ApiResponse<FilterDomainWire>>()
      .single();

    return response.data;
  },

  loadFiltersMetadata: async (endpoints: DefaultFiltersEndpoints, domainIds: number[]): Promise<DefaultFilterMetadataWire[]> => {
    const response = await new RemoteAdminData(endpoints.filterMetadata)
      .resource<ApiResponse<DefaultFilterMetadataWire[]>>()
      .filter({ id: domainIds })
      .all();

    return response.data;
  }
};
